/*
 ------------------------------------------------------------------
|  Copyright (c) 2015 Izenda, Inc.                                 |
|  ALL RIGHTS RESERVED                                             |
|                                                                  |
|  The entire contents of this file is protected by U.S. and       |
|  International Copyright Laws. Unauthorized reproduction,        |
|  reverse-engineering, and distribution of all or any portion of  |
|  the code contained in this file is strictly prohibited and may  |
|  result in severe civil and criminal penalties and will be       |
|  prosecuted to the maximum extent possible under the law.        |
|                                                                  |
|  RESTRICTIONS                                                    |
|                                                                  |
|  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           |
|  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          |
|  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              |
|  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    |
|  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 |
|                                                                  |
|  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      |
|  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        |
|  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       |
|  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  |
|  AND PERMISSION FROM IZENDA INC.                                 |
|                                                                  |
|  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  |
|  ADDITIONAL RESTRICTIONS.                                        |
 ------------------------------------------------------------------
*/

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import { Table, Column } from 'share/components/controls/DataGrid/Izenda.Table';
import { constant, isEmpty, map } from 'lodash/fp';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Button from 'share/components/controls/Izenda.Button';
import SecurityRulesPopup from './Izenda.SecurityRulesPopup';
import CONSTANT from 'logic/data/Izenda.SecurityRulesConstants';

const { RULES_LIST_TABLE_DEF: TABLE_DEF } = CONSTANT;

class SecurityRulesList extends Component{
  constructor(props) {
    super(props);
  }

  openConfigureRulesPopup = (rulesSet, onSecurityRulesSetSave) => {
    const { props: { loaderManager, store, store : { model }, openPopup}} = this;

    // Reset to the first step
    model.rowLevelSecurityStepNumber = 1;
    model.resetQuerySourceTreeFilters();

    loaderManager.startLoading();
    store.getConnectionDetailInfo()
    .then(result => {
      model.populateDataSourceQuerySourceTree(result, rulesSet);
      openPopup(SecurityRulesPopup, {store: store, rulesSet: rulesSet, onSecurityRulesSetSave: onSecurityRulesSetSave });
      return null;
    })
    .finally(loaderManager.endLoading.bind(loaderManager));
  }

  addSecurityRulesSet = () => {
    const { props: { store: { model } }, openConfigureRulesPopup } = this;

    const rulesSet = model.createNewSecurityRulesSet();

    const onSecurityRulesSetSave = (rulesSet) => {
      model.addSecurityRulesSet(rulesSet);
    }  

    openConfigureRulesPopup(rulesSet, onSecurityRulesSetSave);
  }

  renderDescriptionCell = (rulesSet) => {
    const { props: { localization } } = this;

    const description = rulesSet.description || localization.getText('SECURITY_RULES_LIST_TEXT_NO_DESCRIPTION');
    return (<span>{description}</span>);
  }

  renderNameCell = (rulesSet) => {
    const { props: { localization } } = this;

    const name = rulesSet.name || localization.getText('SECURITY_RULES_LIST_TEXT_NO_NAME');
    return (<span>{name}</span>);
  }

  renderActionCell = (rulesSet) => {
    const { props: { localization, store: { model } }, openConfigureRulesPopup } = this;

    const editSecurityRulesSet = () => {
      const clone = rulesSet.clone(true);
      const onSecurityRulesSetSave = (rulesSet) => {
        model.updateSecurityRulesSet(rulesSet);
      }
      openConfigureRulesPopup(clone, onSecurityRulesSetSave);
    }

    const cloneRule = () => {
      const clone = rulesSet.clone();
      model.addSecurityRulesSet(clone);
    };

    const deleteRule = () => {
      model.deleteRulesSet(rulesSet);
    };

    return (
      <div>
        <a onClick={editSecurityRulesSet}><span title={localization.getText('SECURITY_RULES_LIST_TOOLTIP_EDIT_RULES_SET')} className="icon-edit" /></a>
        <span> </span>
        <a onClick={cloneRule}><span title={localization.getText('SECURITY_RULES_LIST_TOOLTIP_CLONE_RULES_SET')} className="icon-copy" /></a>
        <span> </span>
        <a onClick={deleteRule}><span title={localization.getText('SECURITY_RULES_LIST_TOOLTIP_DELETE_RULES_SET')} className="icon-cancel" /></a>
      </div>
    );
  }

  onRuleMove = (oldPosititon, newPosititon, rulesSet) => {
    const { props: { store: { model } } } = this;
    model.moveSecurityRulesSet(oldPosititon, newPosititon, rulesSet);
  }

  render(){
    const { addSecurityRulesSet, props: { store: { model }, localization } } = this;

    const rulesSetList = model.getActiveSecurityRulesSet();

    return (
      <div>
        <GridLayout className="u_paddingAll">
          <GridLayout.Row>
            <GridLayout.Col cols={6} className="u_controlHeight">{localization.getText('SECURITY_RULES_LIST_TITLE_ROW_LEVEL_SECURITY')}</GridLayout.Col>
            <GridLayout.Col cols={6} className="u_textRight">
              <Button onClick={addSecurityRulesSet} className="btn-report-default" label={localization.getText('SECURITY_RULES_LIST_LABEL_ADD_RULES_SET')} />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
        <Table
          dataSource={rulesSetList}
          isLoading={true}
          draggableTable={true}
          canDrag={constant(true)}
          canDrop={constant(true)}
          move={this.onRuleMove}>
            <Column {...TABLE_DEF['name']} cell={this.renderNameCell} />
            <Column {...TABLE_DEF['description']} cell={this.renderDescriptionCell} />
            <Column {...TABLE_DEF['action']} cell={this.renderActionCell} />
        </Table>
      </div>
    );
  }
}

export default connect()(SecurityRulesList);



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/SecurityRules/Izenda.SecurityRulesList.jsx